<template lang='pug'>
  v-col(sm='12')
    v-row(no-gutters)
      v-col(style='padding: 0 20px')
        md-card
          md-card-header.md-card-header-icon.md-card-header-green
            .card-icon
              md-icon settings
            h4.title
              | {{ $t("webChannel.Cors.title") }}
          md-card-content
            form.form-horizontal(action method='post')
              .md-layout
                .md-layout-item(style='margin: auto;')
                  | {{
                  | $t(
                  | "webChannel.Cors.subitems.enableUserRatings"
                  | )
                  | }}
                .md-layout-item.md-form-label.md-size-15(style='padding: 0; margin: auto;' :class="{\
                'text-success': canalWebData.isCorsEnable,\
                'text-danger': !canalWebData.isCorsEnable\
                }")
                  | {{
                  | canalWebData.isCorsEnable
                  | ? $t("commonWords.enabled")
                  | : $t("commonWords.disabled")
                  | }}
                .md-layout-item.md-size-15
                  md-switch(v-model='canalWebData.isCorsEnable')
              .md-layout
                .md-layout-item
                md-field(solo)
                  md-textarea(v-model='domains' placeholder="Por exemplo: \ndomain.com\ndomain.net\ndomain.org")
</template>

<script>
export default {
  props: {
    canalWebData: {
      type: Object,
      required: true
    }
  },
  watch: {
    domains (nV) {
      this.canalWebData.domains = nV.split('\n')
    }
  },
  data () {
    return {
      domains: Array.isArray(this.canalWebData.domains)
        ? this.canalWebData.domains.join('\n')
        : this.canalWebData.domains
    }
  }
}
</script>
